import React from "react";

import { AppHeader } from "../../components/header/header";
import { BodySpacer } from "../../components/utilities/body-spacer";
import { SliderCarousel } from "../../components/carousel/carousel";

import "../../styles/gallery.css";
import { imageGroup1, imageGroup2 } from "../../_helpers/gallery-images";
import { PageCaptionImage } from "../../components/page-components/page-caption-box";
import { AppFooter } from "../../components/footer/footer";

export const Gallery = () => {

    return(
        <div className="page-body">
            <AppHeader />
            <BodySpacer />
            <PageCaptionImage
                caption={"Gallery"}
                imageUrl={'/images/gallery.jpg'} 
            />
            <div className="gallery-page">
                <SliderCarousel  data={imageGroup1} />
                <SliderCarousel data={imageGroup2} />
            </div>
            <AppFooter />
        </div>
    )
}